import type { AutoSaveStatus } from 'hooks/useDebouncedFieldAutosave';
import { createEditorContext } from './createEditorContext';

const { Provider, useEditorContext } =
  createEditorContext<Record<string, AutoSaveStatus>>('AutosaveStatus');

export const AutosaveStatusProvider = Provider;
export const useAutosaveStatusContext = useEditorContext;
